import { connect } from "react-redux";
import ChangeStatus from "containers/Appraiser/ChangeStatus/ChangeStatus";
import { changeStatus as CHANGE_STATUS } from "actions/homeowner/dashboard/index";
import { getCaseHeader } from "actions/homeowner/caseforms";

const mapStateToProps = (state) => {
  return {
    fetchingHeader: state.caseForms.fetchingHeader,
    caseHeader: state.caseForms.caseHeader,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeStatus(controlNumber, action) {
    dispatch(CHANGE_STATUS(controlNumber, action));

  },
  getCaseHeader(controlNumber) {
    dispatch(getCaseHeader(controlNumber));
  }

});

export default connect(mapStateToProps, mapDispatchToProps)(ChangeStatus);
